// extracted by mini-css-extract-plugin
export default {"msgM":"_859a0911e2"};